const angularBootstrapConfig = ($httpProvider, $locationProvider) => {
	$httpProvider.interceptors.push("cayuseHttpInterceptor");

	$locationProvider.html5Mode({
		enabled: true,
		requireBase: false
	});
};
angularBootstrapConfig.$inject = [ "$httpProvider", "$locationProvider" ];

export default angularBootstrapConfig;
